import React from 'react';
import PropTypes from 'prop-types';

class CountrySelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedCountryCode: props.selectedCountryCode };
  }

  componentDidMount() {
    this.addChosen();
    $(this.refs.countrySelect).change(() => this.updateSelectedCountry());
  }

  componentDidUpdate() {
    this.addChosen();
    $(this.refs.countrySelect).trigger('liszt:updated');
  }

  addChosen() {
    $(this.refs.countrySelect).chosen({
      placeholder_text_single: ' ',
      placeholder_text_multiple: ' ',
      search_contains: true,
    });
    this.chosenUI().find('.chzn-search input')
      .attr('placeholder', I18n.t('js.countrySelector.searchPlaceholder'));
  }

  chosenUI() {
    return $(this.refs.countrySelect).next();
  }

  updateSelectedCountry() {
    this.setState({ selectedCountryCode: this.refs.countrySelect.value });
  }

  renderHiddenField() {
    return (
      <input
        type="hidden"
        value={this.state.selectedCountryCode}
        name={this.props.inputName}
      />
    );
  }

  render() {
    if (this.props.hidden) {
      return this.renderHiddenField();
    }

    return (
      <div>
        <select
          defaultValue={this.props.selectedCountryCode}
          ref="countrySelect"
          name={this.props.inputName}
          onChange={() => this.updateSelectedCountry()}
        >
          <option key="" value="">{I18n.t('js.countrySelector.placeholder')}</option>
          {this.props.countries.map(country => (
            <option
              key={country.code}
              value={country.code}
            >
              {country.name}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

CountrySelect.propTypes = {
  inputName: PropTypes.string.isRequired,
  selectedCountryCode: PropTypes.string,
  countries: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  hidden: PropTypes.bool,
};

CountrySelect.defaultProps = {
  hidden: false,
  selectedCountryCode: '',
};

export default CountrySelect;
